/**
 * Root Vuex store. Wires up every active feature module under a store-facing
 * name (left of `import ... from`) that is often *not* the same as the
 * source folder name on the right (e.g. `auth` is really ./userauth,
 * `posts` is really ./feed) — check the import path, not the local name,
 * when tracing a module back to its folder. Folders under src/store/ that
 * are never imported here (auth, block, channels, follow, main, metrics,
 * modal, notifications, org, posts, siwf, twoFactorAuth, user) are dead
 * code, unused anywhere in the app — kept for reference/possible reuse
 * rather than wired in.
 */
import { createStore } from 'vuex';

import auth from './userauth/index.js';
import siwf from './siwfauth/index.js';
import user from './member/index.js';
// import block from './block/index.js';
import restrict from './restrict/index.js';
import subscribe from './subscribe/index.js';
import main from './home/index.js';
import modals from './popup/index.js';
import posts from './feed/index.js';
import notifications from './alerts/index.js';
import analytics from './analytics/index.js';
import org from './group/index.js';
import channels from './spaces/index.js';
import groupchannel from './groupchannel/index.js';
import twoFactorAuth from './securityAuth/index.js';
import messages from './messages/index.js';

const store = createStore({
  modules: {
    auth,
    siwf,
    main,
    modals,
    notifications,
    // block,
    restrict,
    subscribe,
    posts,
    user,
    analytics,
    org,
    channels,
    groupchannel,
    twoFactorAuth,
    messages
  },
});

export default store;
